import { current } from '@reduxjs/toolkit'

import { initialState } from './importExternalSource'
import {
  SCHOOL_IMPORT_STATUS_CENCELED,
  SCHOOL_IMPORT_STATUS_COMPLETED,
  SCHOOL_IMPORT_STATUS_FAILED,
} from 'app/main/subscribersV4/AddSubscibers/components/newImport/constansts'

export const resetImportExternalSourceData = () => initialState

export const setIsOpenImportDialog = (state, actions) => {
  state.isOpenImportDialog = actions.payload
}

export const setIsOpenImportProgressDialog = (state, actions) => {
  state.isOpenImportProgressDialog = actions.payload
}

export const setIsOpenImportedSubscribersResultDialog = (state, actions) => {
  state.isOpenImportedSubscribersResultDialog = actions.payload
}

export const setShowProgressBar = (state, actions) => {
  state.showProgressBar = actions.payload
}

export const setSchoolImportProcessStatus = (state, actions) => {
  const { schoolImportProcessStatusData } = current(state)
  const { status } = actions.payload

  if (status === SCHOOL_IMPORT_STATUS_COMPLETED) {
    state.isOpenImportProgressDialog = false
    state.isOpenImportedSubscribersResultDialog = true
    state.isListenSocketSchoolImport = false
  } else if (
    status === SCHOOL_IMPORT_STATUS_FAILED ||
    status === SCHOOL_IMPORT_STATUS_CENCELED
  ) {
    state.isOpenImportProgressDialog = false
    state.isListenSocketSchoolImport = false
    state.showProgressBar = false
  }
  state.schoolImportProcessStatusData = {
    ...schoolImportProcessStatusData,
    ...actions.payload,
  }
}

export const setIsListenSocketSchoolImport = (state, actions) => {
  state.isListenSocketSchoolImport = actions.payload
}
